<div class="container">
  <div class="content">
    <div class="info-section">
      <div class="icon">
        <img [src]="iconPath || getDefaultIconPath()" alt="" />
      </div>
      <div class="text-content">
        <p class="title">{{ title }}</p>
        <p class="description">{{ description }}</p>
      </div>
    </div>
    <div class="actions" *ngIf="actionButton">
      <lib-ui-button
        variant="filled"
        size="l"
        [fullWidth]="false"
        (click)="clickEvent.emit($event)"
        [label]="buttonText"
      ></lib-ui-button>
    </div>
  </div>
</div>
